import { Box, Typography, Button, Paper, } from "@mui/material";

import HeroBanner from "../HeroBanner";
import ProfileBanner from "../ProfileBanner";
import FirstDayDetailsBanner from "../FirstDayDetailsBanner";

import hero2 from "../../assets/hero2.jpg";
import profile from "../../assets/profile.jpg";

import btnStyles from "../../styles/buttons.module.scss";

export default function WelcomeSection({
    starterData,
    completed = false,
    submissionSuccessReturn = false,
    onStart
}) {

    return (
        <>
            <HeroBanner
                title={`Welcome to the team, ${starterData.firstName}!`}
                subtitle="We are delighted that you have chosen to join our team."
                subtitle2="If you have any questions, please get in touch with your Line Manager, Andrew Rowley or the HR Team."
                titleFontSize="2rem"
                subtitleFontSize="1rem"
            />

            <ProfileBanner
                title="A quick welcome message from our CEO, Trevor Wragg"
                description={
                    <>
                        <p>
                            On behalf of the entire team, may we take this
                            opportunity to extend you a very warm welcome to
                            the Horbury Group. We are delighted that you have
                            made the decision to join us.
                        </p>

                        <p>
                            Horbury has now been established for over 25 years
                            and we take great pride in the fact that many of our
                            staff have been with us for a good number of years.
                            Although now a major force in the industry, we
                            manage to retain a family feel to the business and
                            see it as our role to nurture, support and help you
                            advance your career and most importantly for you to
                            enjoy working with us.
                        </p>

                        <p>
                            We send our best wishes for a long and successful
                            future with the Horbury Group.
                        </p>
                    </>
                }
                image={profile}
            />

            <HeroBanner
                title="Before you start"
                subtitle="We know there are plenty of things to think about when starting a new role!"
                subtitle2="To get you off to the best possible start and ensure we have the information we need, there are a number of things we need you to do before your first day."
                background={hero2}
                titleFontSize="2rem"
                subtitleFontSize="1rem"
            />

            <Paper
                elevation={3}
                 sx={{
                    maxWidth: 1200,
                    mx: "auto",
                    mt: 4,
                    mb: 4,
                    px: { xs: 2, md: 4 },
                    py: 3,
                    borderRadius: 2
                }}
            >
                <Typography variant="h1" sx={{ fontSize: "2rem", fontWeight:700 }}>
                    New Starter Form
                </Typography>

                <Typography sx={{ mt: 2 }}>
                    Use the button below to complete your New Starter Form.
                    This needs to be completed before your first day.
                </Typography>

                <Box sx={{ mt: 5 }}>
                    <Button
                        className={btnStyles.btnDesktop}
                        variant="contained"
                        size="large"
                        sx={{ textTransform: "none" }}
                        disabled={completed || submissionSuccessReturn}
                        onClick={onStart}
                    >
                        {completed
                            ? "New Starter Form Completed"
                            : "Start New Starter Form"}
                    </Button>
                </Box>

                <Typography sx={{ mt: 2 }}>
                    Please note that once this form has been submitted, it
                    cannot be edited. Should you require any amendments to the
                    information you have submitted, please contact us at
                    careers@horburygroup.com.
                </Typography>
            </Paper>
            <Paper
                elevation={3}
                 sx={{
                    maxWidth: 1200,
                    mx: "auto",
                    mt: 4,
                    mb: 4,
                    px: { xs: 2, md: 4 },
                    py: 3,
                    borderRadius: 2
                }}
            >
                <FirstDayDetailsBanner
                startDate={starterData.action?.startDate}
                location={starterData.action?.startLocation}
                contactName={starterData.action?.keyContactName}
                contactRole={starterData.action?.keyContactJobTitle}
                contactNumber={starterData.action?.keyContactPhone}
            />

            </Paper>
            
        </>
    );
}